/*
 * -----------------------------------------------------------------------
 *  <copyright file="snapshots.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';

export const CREATE_SNAPSHOT = gql`
    mutation snapshot($organisationKey: ObjectId!, $snapshotName: String!) {
        snapshot(organisationKey: $organisationKey, snapshotName: $snapshotName)
    }
`;

export const DELETE_SNAPSHOT = gql`
    mutation deleteSnapshot($snapshotName: String!) {
        deleteSnapshot(snapshotName: $snapshotName)
    }
`;

export const RESTORE_SNAPSHOT = gql`
    mutation restoreSnapshot($connectionString: String, $name: String, $reason: String!,
        $region: DataStorageRegion!, $snapshotName: String!, $urlPath: String!, $useTransactions: Boolean) {
        restoreSnapshot(connectionString: $connectionString, name: $name, reason: $reason,
            region: $region, snapshotName: $snapshotName, urlPath: $urlPath, useTransactions: $useTransactions)
    }
`;

export const GET_RESTORE_SNAPSHOT_STATUS = gql`
    query restoreSnapshotStatus($statusId: ObjectId!) {
        restoreSnapshotStatus(statusId: $statusId) {
            error
            isFinished
        }
    }
`;

export const GET_SNAPSHOT_STATUS = gql`
    query snapshotStatus($statusId: ObjectId!) {
        snapshotStatus(statusId: $statusId) {
            error
            isFinished
        }
    }
`;

export const GET_DELETE_SNAPSHOT_STATUS = gql`
    query deleteSnapshotStatus($statusId: ObjectId!) {
        deleteSnapshotStatus(statusId: $statusId) {
            error
            isFinished
        }
    }
`;


export const GET_SNAPSHOTS = gql`
    query snapshots {
        snapshots
    }
`;

